import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchWithAutocompleteComponent } from './search-with-autocomplete.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
    declarations: [SearchWithAutocompleteComponent],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatInputModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
    ],
    exports: [SearchWithAutocompleteComponent],
})
export class SearchWithAutocompleteModule {}
